export const alarmSound = '/alarm.798a570.mp3';
export const pdfWorker = '/pdf.worker.a53a71a.js';
export const atemschutzAlarmSound = '/eieruhr.66cef4e.mp3';
export const shapefileUrl = '/shapefile.31a685f.js';
export const resetPage = '/reset.4d66f4a.html';

export const heroImages = [
  { type: 'image/webp', src: '/hero.157f025.webp' },
  { type: 'image/jpeg', src: '/hero.83ea7e4.jpeg' },
];
